<template>
  <div>
    <van-nav-bar
      title="监管码列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-icon name="cart" size="30" @click="goIndex()"/>
      </template>
    </van-nav-bar>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item v-for="(detail,index) in list" title="需采集数据" :name=index>
        <van-field
          :readonly="true"
          v-model="detail.item.no"
          name="商品编号"
          label="商品编号"
        />
        <van-field
          :readonly="true"
          v-model="detail.item.name"
          name="商品名称"
          label="商品名称"
        />
        <van-field
          :readonly="true"
          v-model="detail.pack.specification"
          name="包装规格"
          label="包装规格"
        />
        <van-field
          :readonly="true"
          v-model="detail.lot.no"
          name="批号"
          label="批号"
        />
        <van-field
          :readonly="true"
          v-model="detail.command.quantity"
          name="数量"
          label="数量"
        />
        <van-field
          :readonly="true"
          v-model="detail.command.quantity"
          name="采集数"
          label="采集数"
        />
        <van-button type="primary" @click="itemClick(detail)">采集</van-button>
      </van-collapse-item>

    </van-collapse>

  </div>
</template>


<script>


import { findAll } from '@/api/Api'

export default {
  name: 'ReceiptSupervisionCodeList',
  data() {
    return {
      list: [],
      activeNames: []

    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' }, (res) => {
      })
    },
    getData() {
      const args = this.$route.params.args
      findAll('supervisionCommandReceiptFactory', args).then((res) => {
        if (res.success) {
          this.list = res.result
        }
      })
    },
    itemClick(data) {
      this.$router.push({ name: 'Receipt', params: { detail: data } }, (res) => {

      })
    }
  },
  created: function() {// 创建生命周期}
    this.getData()
  }

}


</script>